import React,{useState, useEffect, Component} from 'react'; 
import styled from "styled-components"


const MobileRechargePlan = (props) => {

    const {getRechargePlansResponse} = props;

    


   
 
 
    const showViewPlan = (val)=>{
        return(
            <div id="ViewPlanButton">
                
              
            </div>
        );  
    }
    return (
        <React.Fragment>

            {showViewPlan()}
 

        </React.Fragment>
    );
};


export default MobileRechargePlan;